import { render, staticRenderFns } from "./AdditionalOwnersInfo.vue?vue&type=template&id=6c475c4f&scoped=true&"
import script from "./AdditionalOwnersInfo.vue?vue&type=script&lang=js&"
export * from "./AdditionalOwnersInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalOwnersInfo.vue?vue&type=style&index=0&id=6c475c4f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c475c4f",
  null
  
)

export default component.exports